export default __webpack_public_path__ + "slices/main/assets/public/media/product/amplify/effectiveness-focus-areas@2x.50235ef4dae825cb6df3510954f2d160.png";